module.exports = __webpack_public_path__ + "static/media/outscale.bd3f0316.png";